import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef } from 'react';
import { Fias, FiasSchema } from '@skbkontur/react-ui-addons';
import { checkValueEmpty } from '../../helpers/checkValueEmpty';
import { isAddressEqual } from '../../helpers/isAddressEqual';
import { normalizeObject } from '../../helpers/normalizeObject';
import { AddressButton } from '../AddressButton';
import { fiasFieldsSettings } from './FiasOverrider.constants';
import { getFiasApiUrl, isDefaultAddress } from './FiasOverrider.helpers';
import { convertFiasAddressToSSAddress } from './сonversion/convertFiasAddressToSSAddress';
import { convertSSAddressToFiasAddress } from './сonversion/convertSSAddressToFiasAddress';
import classes from './FiasOverrider.module.css';
export const FiasOverrider = ({ value, onValueChange, validationInfo, onOpen, onClose, }) => {
    const refFias = useRef(null);
    const handleAddressClick = () => {
        refFias.current?.open();
        onOpen?.();
    };
    const handleValueChange = (newAddress) => {
        const normalizedAddress = normalizeObject(convertFiasAddressToSSAddress(newAddress));
        if (isAddressEqual(normalizedAddress, value)) {
            return;
        }
        if (isDefaultAddress(normalizedAddress)) {
            onValueChange({});
            return;
        }
        onValueChange(normalizedAddress);
    };
    const handleInitFias = (newAddress) => {
        const normalizedAddress = normalizeObject(convertFiasAddressToSSAddress(newAddress));
        const { residenceDate, ...rest } = value;
        // Дефолтный адрес не сохраняем в стейт.
        // При конвертации в значение фиаса он будет установлен в форме
        if (!value || checkValueEmpty(value) || isDefaultAddress(normalizedAddress)) {
            return;
        }
        if (isAddressEqual(normalizedAddress, rest)) {
            return;
        }
        onValueChange(normalizedAddress);
    };
    useEffect(() => {
        if (Object.entries(value).length > 0 && !value.text) {
            refFias.current?.componentDidMount();
        }
    }, [value]);
    return (_jsxs(_Fragment, { children: [_jsx(Fias, { search: true, ref: refFias, allowNotVerified: true, countrySelector: true, schema: FiasSchema.Gar, onInit: handleInitFias, baseUrl: getFiasApiUrl(), className: classes.hidden, onValueChange: handleValueChange, fieldsSettings: fiasFieldsSettings, value: convertSSAddressToFiasAddress(value || {}), onClose: onClose }), _jsx(AddressButton, { onClick: handleAddressClick, validationInfo: validationInfo })] }));
};
